class HeatMapItem {
    constructor() {
        this.x1 = 0;
        this.x2 = 0;
        this.y1 = 0;
        this.y2 = 0;
        this.value = 0;
        this.value1 = 0;
        this.value2 = 0;
        this.name = "";
        this.label = "";
        this.category = "";
        this.subcategory = "";
        this.subitem = "";
        this.range = 0;
        this.pc = 0;
        this.categoryid = 0;
        this.subcategoryid = 0;
        this.ls = 0;
        this.nc = 0;
        this.scaledValue = 0; // used for squarify
    }

    getX1() {
        return this.x1;
    }

    setX1(x1) {
        this.x1 = x1;
    }

    getX2() {
        return this.x2;
    }

    setX2(x2) {
        this.x2 = x2;
    }

    getY1() {
        return this.y1;
    }

    setY1(y1) {
        this.y1 = y1;
    }

    getY2() {
        return this.y2;
    }

    setY2(y2) {
        this.y2 = y2;
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = value;
    }

    getValue1() {
        return this.value1;
    }

    setValue1(value1) {
        this.value1 = value1;
    }

    getValue2() {
        return this.value2;
    }

    setValue2(value2) {
        this.value2 = value2;
    }

    getName() {
        return this.name;
    }

    setName(name) {
        this.name = name;
    }

    getLabel() {
        return this.label;
    }

    setLabel(label) {
        this.label = label;
    }

    getCategory() {
        return this.category;
    }

    setCategory(category) {
        this.category = category;
    }

    getSubcategory() {
        return this.subcategory;
    }

    setSubcategory(subcategory) {
        this.subcategory = subcategory;
    }

    getSubitem() {
        return this.subitem;
    }

    setSubitem(subitem) {
        this.subitem = subitem;
    }

    getRange() {
        return this.range;
    }

    setRange(range) {
        this.range = range;
    }

    getPc() {
        return this.pc;
    }

    setPc(pc) {
        this.pc = pc;
    }

    getCategoryid() {
        return this.categoryid;
    }

    setCategoryid(categoryid) {
        this.categoryid = categoryid;
    }

    getSubcategoryid() {
        return this.subcategoryid;
    }

    setSubcategoryid(subcategoryid) {
        this.subcategoryid = subcategoryid;
    }

    getLs() {
        return this.ls;
    }

    setLs(ls) {
        this.ls = ls;
    }

    getNc() {
        return this.nc;
    }

    setNc(nc) {
        this.nc = nc;
    }

    getLeft() {
        if (this.x1 > this.x2) {
            return this.x2;
        } else {
            return this.x1;
        }
    }

    getTop() {
        if (this.y1 > this.y2) {
            return this.y2;
        } else {
            return this.y1;
        }
    }

    getWidth() {
        if (this.x1 > this.x2) {
            return (this.x1 - this.x2);
        } else {
            return (this.x2 - this.x1);
        }
    }

    getHeight() {
        if (this.y1 > this.y2) {
            return (this.y1 - this.y2);
        } else {
            return (this.y2 - this.y1);
        }
    }

    getScaledValue() {
        return this.scaledValue;
    }

    setScaledValue(scaledValue) {
        this.scaledValue = scaledValue;
    }

    toString() {
        return "name = " + this.getName() +
               ",top = " + this.getTop() +
               ",left = " + this.getLeft() +
               ",width = " + this.getWidth() +
               ",height = " + this.getHeight()
    }

    // JavaScript equivalent of compareTo method for Comparable interface
    compareTo(o) {
        const item = o;
        return -1 * (this.getValue() - item.getValue());
    }

    // For JavaScript array sorting compatibility
    static compare(a, b) {
        return a.compareTo(b);
    }
}

// Export for use in modules
if (typeof module !== 'undefined' && module.exports) {
    module.exports = HeatMapItem;
}

// Export for ES6 modules
export default HeatMapItem; 